<template>
  <div>

    <div class="title-section">
      <div class="display-1 font-weight-bold">{{meta.title}}</div>
      <div class="subheading">{{meta.subtitle}}</div>
    </div>


    <v-divider class="spacer"/><div class="headline font-weight-bold">Checkpoint 3</div><v-divider class="div-after"/>
    <div class="body-1">
      The work for this checkpoint covers the implementation of an illumination model. 
      Specifically, <span class="font-weight-bold">Phong</span>! I did also implement a
      simple animation and FPS counter to test current performance, though I'll be 
      diving into those concerns in a later update. Here are some resulting images
      from this checkpoint's work!
    </div>
    
    <v-img class="u-image" :src="require(`../assets/updates/5/basic_image.png`)"/>
      <div class="font-weight-medium">Basic image with Phong illumination</div>

    <v-img class="u-image" :src="require(`../assets/updates/5/two_lights.png`)"/>
      <div class="font-weight-medium">Now with two lights!</div>

    <v-img class="u-image" :src="require(`../assets/updates/5/one_intense.png`)"/>
      <div class="font-weight-medium">Increasing the intensity of one light</div>

    <v-img class="u-image" :src="require(`../assets/updates/5/two_lights_2.png`)"/>
      <div class="font-weight-medium">Playing with the light positions/intensity</div>

    <v-img class="u-image" :src="require(`../assets/updates/5/varied_lights.png`)"/>
      <div class="font-weight-medium">Interesting effects with varied light colors</div>
    

    <v-divider class="spacer"/><div class="headline font-weight-bold">Additional images</div><v-divider class="div-after"/>
    <div class="body-1">
      The following image was created by not normalizing the reflection vector! It
      has a really interesting effect, though it doesn't exactly look right. 
    </div>

    <v-img class="u-image" :src="require(`../assets/updates/5/interesting.png`)"/>
      <div class="font-weight-medium">Looks cool, but not-so-right</div>

    <div class="body-1">
      And here are some additional images where I messed around the the amount
      of ambient/diffuse/specular light that each object gives off. 
    </div>

    <v-img class="u-image" :src="require(`../assets/updates/5/low_spec_exp.png`)"/>
      <div class="font-weight-medium">Smaller specular coefficient (5)</div>

    <v-img class="u-image" :src="require(`../assets/updates/5/no_ambient.png`)"/>
      <div class="font-weight-medium">Low ambient, high specular</div>

    <v-img class="u-image" :src="require(`../assets/updates/5/no_ambient_weak_light.png`)"/>
      <div class="font-weight-medium">Low ambient, with a weaker light</div>

  </div>
</template>

<script>
import CardList from '../components/CardList';

export default {
  name: 'U_5',
  components: { CardList, },
  data() {
    return {
      
    };
  },
  computed: {
    meta() {
      return this.$store.state.updates[5];
    },
  },
}
</script>

<style>

</style>
